const additionalPriceModelData = [
  {
    id: '1M',
    color: '#999999',
    subtitle: 'monatliche Abrechnung',
    hint: 'monatlich kündbar',
    hintIndicator: '*',
    info: 'Bleiben Sie flexibel! Mit nur 1 Monat Laufzeit können Sie jederzeit Ihre benötigten User frei skalieren. Kündbar jeweils zum Ende des nächsten Monats. Ein Wechsel in unsere Laufzeit-Tarife ist übrigens problemlos möglich.',
  },
  {
    id: '12Mm',
    color: '#737373',
    subtitle: 'monatliche Abrechnung',
    hint: 'jährlich kündbar',
    hintIndicator: '**',
    advantage: {
      bgColor: 'agfeo-yellow-light',
      textColor: 'agfeo-red',
      value: '10%',
    },
    info: 'Nutzen Sie unseren Laufzeittarif für 12 Monate mit monatlicher Rechnung und sparen Sie zum 1 Monatstarif über 10%. Übrigens können Sie jederzeit noch weitere User im 1 Monatstarif für Saisongeschäft etc. dazu buchen. Der Vertrag ist kündbar mit einer Frist von 3 Monaten zum Ende der Laufzeit.',
  },
  {
    id: '12Mj',
    color: '#4D4D4D',
    subtitle: 'jährliche Abrechnung',
    hint: 'jährlich kündbar',
    hintIndicator: '**',
    advantage: {
      bgColor: 'agfeo-red',
      textColor: 'white',
      value: '20%',
    },
    info: 'Nutzen Sie das höchste Sparpotential mit einer Laufzeit von 12 Monaten bei jährlicher Prepaid-Rechnung und sparen Sie zum 1 Monatstarif über 20%. Trotzdem können Sie jederzeit noch User im 1 Monatstarif dazu buchen. Der Vertrag ist kündbar mit Frist von 3 Monaten zum Ende der Laufzeit.',
  },
]

/**
 * Groups the flat list of the price-steps based on their related model.
 *
 * @returns {array}
 */
export function groupPricingOptions (pricingOptions) {
  const order = ['1M', '12Mm', '12Mj']
  const options = pricingOptions.reduce((options, entry) => {
    const { term_model: model, min_users: min, max_users: max, price_net: price } = entry
    const target = options.find(({ modelId }) => modelId === model.term_model_id)

    target
      ? target.priceSteps.push({ min, max, price })
      : options.push({
        modelId: model.term_model_id,
        termModel: model,
        priceSteps: [{ min, max, price }],
        additionalData: additionalPriceModelData.find(({ id }) => id === model.term_model_id),
      })

    return options
  }, [])

  return options.sort((a, b) => order.indexOf(a.modelId) - order.indexOf(b.modelId))
}
